module.exports = __webpack_public_path__ + "static/img/3.5d76bbb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nationalDay/card/3.png
// module id = DVX7
// module chunks = 2